import {
  AbsolutesBlackColors,
  AbsolutesWhiteColors,
} from '@picsart/design-system/foundation/colors';

import { ColorScheme } from 'strapi/types';

export function getTextColorByCMSData(input: ColorScheme) {
  switch (input) {
    case 'light': {
      return AbsolutesWhiteColors.base.default;
    }
    case 'dark': {
      return AbsolutesBlackColors.base.default;
    }
    default: {
      return AbsolutesWhiteColors.base.default;
    }
  }
}
